<nav class="fixed-top  backgroundTheme">
  <div>
    <div class="textoArriba">
      <div class="organizadorBaner"
        [ngClass]="{'organizadorBaner-top-40': showBanner, 'organizadorBaner-top-25': !showBanner}"
        *ngIf="retroSelected">
        <div class="container">
          <div class="row">
            <div class="col divFlecha">
              <button (click)="this.regresarPagina()" style="border: 0px; background-color: transparent;">
                <img class="tamano-2 img-responsive" src="./assets/img/Arrow_Big.png">
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="textoAbajo">
      <div class="organizadorBaner"
        [ngClass]="{'organizadorBaner-top-40': showBanner, 'organizadorBaner-top-25': !showBanner}"
        *ngIf="retroSelected">
        <div class="container">
          <div class="row">
            <div class="col divFlecha">
              <button (click)="this.regresarPagina()" style="border: 0px; background-color: transparent;">
                <img class="tamano-2 img-responsive" src="./assets/img/Arrow_Big.png">
              </button>
            </div>
            <div class="col-auto">
              <div>
                <button (click)="this.regresarPagina()"
                  style="border: 0px; background-color: transparent; padding-left: 0px;">
                  <p class="estiloFlechaBanner">Seguro de arriendo</p>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
  <div class="img-container">
    <img name="logo" class="img-responsive img-logo-sura" src="./assets/img/Capa_1-2.svg" width="180" height="55">
  </div>
</nav>
<div class="promo-banner-fixed" *ngIf="showBanner">
  <app-discountbanner></app-discountbanner>
</div>
<div class="promo-banner-body-spacer" *ngIf="showBanner"></div>